import axios from "axios";
import { API } from "../../../api/api";

export const getAGB = () => axios.get(API.url + "/agb?populate=*").then((res) => res.data.data.attributes);

export const getDatenschutz = () => axios.get(API.url + "/datenschutz").then((res) => res.data.data.attributes);

export const getImpressum = () => axios.get(API.url + "/impressum").then((res) => res.data.data.attributes);
